import angular from 'angular';

(function() {
    'use strict';

    var orderHeaderInfo = {
        templateUrl: require('./order-header-info.html'),
        bindings: {
            order: '<' // Commande
        }
    };

    angular.module('app.kissorder').component('orderHeaderInfo', orderHeaderInfo);
})();
